export default {
  // status
  PUBLIC: 0,
  DRAFT: 1,
  DELETED: 2,
};
